import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { ChangeEvent, FC, useMemo } from 'react';
import { useIntegrationDisplayNamesQuery } from 'IntegrationModule/api/queries/useIntegrationDisplayNamesQuery';

export type OverrideItem = {
  value: string;
  name: string;
  disabled?: boolean;
};

export const IntegrationAgentsNameSelector: FC<{
  value: string;
  onChange: (event: ChangeEvent<any>) => void;
  itemsOverride?: OverrideItem[];
  disabled?: boolean;
}> = ({ value, onChange, itemsOverride, disabled }) => {
  const { integrationDisplayNames } = useIntegrationDisplayNamesQuery({
    enabled: !itemsOverride,
  });

  const defaultItems: OverrideItem[] = useMemo(
    () =>
      integrationDisplayNames.map((item) => ({
        value: item.nonDisplayName,
        name: item.displayName,
      })),
    [integrationDisplayNames],
  );

  const items = itemsOverride ?? defaultItems;

  return (
    <FormControl required variant="outlined" className="text-field">
      <InputLabel id="integrationAgentName">Service Name</InputLabel>
      <Select
        labelId="integrationAgentName"
        value={value}
        onChange={onChange as any}
        label="Service Name"
        name="integrationAgentName"
        disabled={disabled}
      >
        {items.map((item: OverrideItem) => {
          return (
            <MenuItem
              key={item.value}
              value={item.value}
              disabled={'disabled' in item ? item.disabled : false}
            >
              {item.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
